/** Vẽ khung Đối chiếu nhanh từ `quickCheckRows`. Không có dòng nào thì ẩn hẳn, không để một thẻ rỗng. */
import { esc } from './util.js';
import { formatMetric } from './metrics.js';

export function renderQuickCheck(host, rows) {
  host.hidden = !rows.length;
  if (!rows.length) {
    host.innerHTML = '';
    return;
  }
  host.innerHTML = `
    <h2 class="card-title"><span class="ms">speed</span>Đối chiếu nhanh</h2>
    <dl class="quick-check">
      ${rows
        .map(
          (r) => `<div class="qc-row${r.tone ? ` is-${r.tone}` : ''}">
            <dt>${esc(r.label)}${r.note ? `<span class="pending-chip">${esc(r.note)}</span>` : ''}</dt>
            <dd>${r.value === null ? '—' : `${esc(formatMetric(r.value))} ${esc(r.unit)}`}</dd>
          </div>`,
        )
        .join('')}
    </dl>`;
}
